import { WeatherServiceTypes } from '@sunrise/types'
import { defineComponent, PropType } from 'vue'
import { weather } from '@sunrise/icons'

export default defineComponent({
    name: 'CsWeatherIcons',
    components: {
        ...weather,
    },
    props: {
        iconName: {
            type: String as PropType<WeatherServiceTypes.WeatherIcons>,
            required: true,
        },
    },
})
